import { HomeSlickComponent } from "front-end/components/homeslick.component";
import { IBannerDetailsMediaComponent } from "../banner-details-media.component";

export class ImagesSliderComponent extends HomeSlickComponent implements IBannerDetailsMediaComponent {
    public static SELECTOR: string = ".js-ina-images-slider-list";

    private _sliderOptions = {
        dots: true,
        arrows: false
    };

    public init(context: JQuery): void {
        super.init(context, this._sliderOptions);
    }

    public dispose(): void {
        this.destroy();
    }
}
